<div class="error-message">
  <div>{{ props["message"] }}</div>
</div>
